const query = `query ($id: ID!) {
    order(id: $id) {
        name
        id
        number
        createdAt
        cancelledAt
        customer {
            emailAddress {
                emailAddress
            }
        }
        discountApplications(first: 5) {
            edges {
                node {
                    ... on AutomaticDiscountApplication {
                                                title
                                                targetType
                                                targetSelection
                                                allocationMethod
                                                value {
                                                    ... on MoneyV2 {
                                                        amount
                                                        currencyCode
                                                    }
                                                    ... on PricingPercentageValue {
                                                        percentage
                                                    }
                                                }
                                            }
                                            ... on DiscountCodeApplication {
                                                allocationMethod
                                                targetSelection
                                                targetType
                                                code
                                                value {
                                                    ... on MoneyV2 {
                                                        amount
                                                        currencyCode
                                                    }
                                                    ... on PricingPercentageValue {
                                                        percentage
                                                    }
                                                }
                                            }
                                            ... on ManualDiscountApplication {
                                                allocationMethod
                                                targetSelection
                                                targetType
                                                title
                                                description
                                                value {
                                                    ... on MoneyV2 {
                                                        amount
                                                        currencyCode
                                                    }
                                                    ... on PricingPercentageValue {
                                                        percentage
                                                    }
                                                }
                                            }
                }
            }
        }
        fulfillments(first: 100) {
            edges {
                node {
                    id
                    estimatedDeliveryAt
                    fulfillmentLineItems(first: 100) {
                        edges {
                            node {
                                quantity
                                lineItem {
                                    totalDiscount {
                                        amount
                                        currencyCode
                                    }
                                    currentTotalPrice {
                                        amount
                                        currencyCode
                                    }
                                    discountAllocations {
                                        allocatedAmount {
                                            amount
                                        }
                                        discountApplication {
                                            ... on AutomaticDiscountApplication {
                                                title
                                                targetType
                                                targetSelection
                                                allocationMethod
                                                value {
                                                    ... on MoneyV2 {
                                                        amount
                                                        currencyCode
                                                    }
                                                    ... on PricingPercentageValue {
                                                        percentage
                                                    }
                                                }
                                            }
                                            ... on DiscountCodeApplication {
                                                allocationMethod
                                                targetSelection
                                                targetType
                                                code
                                                value {
                                                    ... on MoneyV2 {
                                                        amount
                                                        currencyCode
                                                    }
                                                    ... on PricingPercentageValue {
                                                        percentage
                                                    }
                                                }
                                            }
                                            ... on ManualDiscountApplication {
                                                allocationMethod
                                                targetSelection
                                                targetType
                                                title
                                                description
                                                value {
                                                    ... on MoneyV2 {
                                                        amount
                                                        currencyCode
                                                    }
                                                    ... on PricingPercentageValue {
                                                        percentage
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    customAttributes {
                                        key
                                        value
                                    }
                                    image {
                                        url
                                        width
                                        height
                                    }
                                    price {
                                        amount
                                        currencyCode
                                    }
                                    productType
                                    productId
                                    variantId
                                    quantity
                                    title
                                    name
                                }
                            }
                        }
                    }
                    events(first: 100) {
                        edges {
                            node {
                                status
                            }
                        }
                    }
                    latestShipmentStatus
                    status
                    updatedAt
                    trackingInformation {
                        company
                        number
                        url
                    }
                }
            }
        }
        lineItems(first: 100) {
            edges {
                node {
                    id
                    image {
                        url
                    }
                    price {
                        amount
                    }
                    quantity
                    customAttributes {
                        value
                        key
                    }
                    totalDiscount {
                        amount
                        currencyCode
                    }
                    currentTotalPrice {
                        amount
                        currencyCode
                    }
                    discountAllocations {
                        allocatedAmount {
                            amount
                        }
                        discountApplication {
                            ... on AutomaticDiscountApplication {
                                title
                                targetType
                                targetSelection
                                allocationMethod
                                value {
                                    ... on MoneyV2 {
                                        amount
                                        currencyCode
                                    }
                                    ... on PricingPercentageValue {
                                        percentage
                                    }
                                }
                            }
                            ... on DiscountCodeApplication {
                                allocationMethod
                                targetSelection
                                targetType
                                code
                                value {
                                    ... on MoneyV2 {
                                        amount
                                        currencyCode
                                    }
                                    ... on PricingPercentageValue {
                                        percentage
                                    }
                                }
                            }
                            ... on ManualDiscountApplication {
                                allocationMethod
                                targetSelection
                                targetType
                                title
                                description
                                value {
                                    ... on MoneyV2 {
                                        amount
                                        currencyCode
                                    }
                                    ... on PricingPercentageValue {
                                        percentage
                                    }
                                }
                            }
                        }
                    }
                    productType
                    productId
                    variantId
                    title
                }
            }
        }
        shippingAddress {
            address1
            address2
            city
            company
            country
            firstName
            formatted
            formattedArea
            lastName
            name
            phoneNumber
            province
            territoryCode
            zip
            zoneCode
        }
        billingAddress {
            address1
            address2
            city
            company
            country
            firstName
            formatted
            formattedArea
            lastName
            name
            phoneNumber
            province
            territoryCode
            zip
            zoneCode
        }
        refunds {
            createdAt
        }
        subtotal {
            amount
            currencyCode
        }
        totalPrice {
            amount
            currencyCode
        }
        totalShipping {
            amount
            currencyCode
        }
        totalTax {
            amount
            currencyCode
        }
        totalRefunded {
            amount
            currencyCode
        }
        transactions {
            kind
            status
            paymentDetails {
                ... on CardPaymentDetails {
                    cardBrand
                    last4
                }
            }
            paymentIcon {
                url
                height
                altText
            }
        }
    }
}
`

export default query
